import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorMasterSubinventoryView = () => {
  const masterSubinventoryView = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/warehouse/master-subinventory/view', payload, (response) => {
      if (response.code === 7200 && response.data) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          redirect: '/administrator/master/subinventory/manage',
        })
      }
      loading(false)
    })
  }, [])
  return { masterSubinventoryView }
}

export default InteractorMasterSubinventoryView
